import React from 'react'
import { motion } from 'framer-motion'
import { Calendar, CheckCircle2, MapPin } from 'lucide-react'
import Container from './Container'

const SimaEventInfo: React.FC = () => {
  return (
    <section className="bg-white py-24 md:py-32 relative">
      <Container size="lg">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6 }}
          >
            <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-accent/10 px-4 py-2 text-sm font-medium text-accent">
              <Calendar className="h-4 w-4" />
              20-23 Mayo 2026
            </div>
            
            <h2 className="font-display text-3xl font-bold text-primary md:text-4xl lg:text-5xl mb-6">
              Nos vemos en IFEMA Madrid
            </h2>
            
            <p className="text-lg text-text-secondary mb-8">
              SIMA es el punto de encuentro del sector inmobiliario. Estaremos en Madrid para reuniones 1:1 con interesados en invertir y diversificar patrimonio en República Dominicana (Punta Cana).
            </p>

            <ul className="space-y-4 mb-8">
              {[
                'Presentación clara de opciones y etapas',
                'Revisión de objetivos y preferencia de proyecto',
                'Recomendación según perfil y presupuesto'
              ].map((item, i) => (
                <li key={i} className="flex items-start">
                  <CheckCircle2 className="h-6 w-6 text-accent flex-shrink-0 mr-3" />
                  <span className="text-text-primary font-medium">{item}</span>
                </li>
              ))}
            </ul>

            <a
              href="#agenda"
              className="inline-flex items-center justify-center rounded-lg bg-primary px-8 py-4 font-semibold text-white transition-all duration-300 hover:bg-primary-light"
            >
              Agendar cita ahora
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative"
          >
            {/* Visual representation of the event/meeting */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] bg-primary/5 border border-border-light">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary/10 to-transparent z-10"></div>
              <img 
                src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?q=80&w=2070&auto=format&fit=crop" 
                alt="Reunión de asesoría inmobiliaria" 
                className="w-full h-full object-cover"
              />
              
              {/* Floating card */}
              <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-md rounded-xl p-6 shadow-xl z-20">
                <div className="flex items-center gap-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-accent/10 text-accent">
                    <MapPin className="h-6 w-6" />
                  </div>
                  <div>
                    <h3 className="font-bold text-primary">Stand Bavarian</h3>
                    <p className="text-sm text-text-secondary">Pabellón Internacional - SIMA</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </Container>
    </section>
  )
}

export default SimaEventInfo
